var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRotateLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRotateLeft") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43808344,2.28458876 L0,2.98266154 L1.84206973,6.83615157 L5.66793315,4.97857479 L4.97616784,3.53174522 L3.70168726,4.15037813 C4.72004247,2.57945486 6.46722308,1.60543477 8.3872139,1.60543477 C11.4738353,1.60543477 13.9861182,4.13735491 13.9861182,7.25 C13.9861182,10.362664 11.4738164,12.8946584 8.3872139,12.8946584 C6.56990153,12.8946584 4.85814339,11.9996091 3.80896784,10.5003223 L3.66457547,10.2939835 L2.36043989,11.2209379 L2.50279824,11.4242806 C3.85109715,13.3501713 6.05058273,14.5 8.3872139,14.5 C12.3554223,14.5 15.58273,11.2474195 15.58273,7.25 C15.58273,3.25256998 12.3554427,0 8.3872139,0 C5.75224936,0 3.36956763,1.42894356 2.11148876,3.69374697 L1.43808344,2.28458876 Z",
    id: "icRotateLeft",
    fill: "#333333",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotateLeft);
export default __webpack_public_path__ + "static/media/icRotateLeft.186afd67ef942d45756a60270398a501.svg";
export { ForwardRef as ReactComponent };